import { Quantity } from "../../models/models";
import { Box, MenuItem, Select, TextField } from "@mui/material";
import React from "react";
import { integerRegex } from "../../validators";
import { MeasurementUnitCode, sortedMeasurementUnits, unitCode } from "../../../common/models/CommonModels";
import { FieldErrors, UseFormRegister, UseFormTrigger } from "react-hook-form";
import useTranslation from "../../hooks/useTranslation";

type QuantityInputProps = {
  quantity?: Quantity
  register: UseFormRegister<any>
  trigger: UseFormTrigger<any>
  errors: FieldErrors<any>
};

const QuantityInput = (props: QuantityInputProps) => {
  const { translate } = useTranslation("common");
  return (
    <Box className="w-full">
      <TextField
        style={{ marginRight: "-1px" }}
        sx={{
          "& fieldset": { borderRadius: '4px 0 0 4px' },
        }}
        className="w-2/3"
        {...props.register("quantity.value", {
          required: "Field is required",
          pattern: { value: integerRegex, message: "Invalid value" }
        })}
        error={!!props.errors.quantity}
      />
      <Select
        sx={{
          "& fieldset": { borderRadius: '0 4px 4px 0' },
        }}
        className="w-1/3"
        key="quantity.unitCode"
        defaultValue={props.quantity?.unitCode || MeasurementUnitCode.pieces}
        onClose={() => setTimeout(() => props.trigger("quantity.unitCode"))}
        {...props.register("quantity.unitCode")}
      >
        {sortedMeasurementUnits.map((code) => (
          <MenuItem key={code} value={code}>
            {translate(`measurementUnits.${unitCode(code)}`)}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default QuantityInput;
